const statusMessages: Record<number, string> = {
  400: "Geçersiz istek. Lütfen girdiğiniz bilgileri kontrol edin.",
  401: "Giriş yapmanız gerekiyor.",
  403: "Bu işlem için yetkiniz yok.",
  404: "Aradığınız kaynak bulunamadı.",
  408: "İstek zaman aşımına uğradı. Lütfen tekrar deneyin.",
  409: "Veri çakışması oluştu.",
  422: "Doğrulama hatası. Girdiğiniz verileri gözden geçirin.",
  429: "Çok fazla istek yapıldı. Bir süre bekledikten sonra tekrar deneyin.",
  500: "Sunucuda bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
  502: "Geçersiz yanıt alındı.",
  503: "Hizmet geçici olarak kullanılamıyor. Daha sonra tekrar deneyin.",
  504: "Sunucu yanıt vermiyor. Lütfen internet bağlantınızı kontrol edin.",
};

/**
 * Status koduna (veya özel bir mesaja) göre Türkçe hata metni döner.
 *
 * @param status HTTP response status code
 * @param customMessage Sunucudan dönmüş özel bir Türkçe mesaj varsa buraya geçilebilir
 * @returns Türkçe hata mesajı
 */
export function getErrorMessage(
  status?: number,
  customMessage?: string
): string {
  // Eğer sunucudan dönmüş özel bir mesaj varsa öncelikle onu göster
  if (customMessage) return customMessage;

  // Status kodu yoksa (örneğin network error)
  if (typeof status !== "number") {
    return "Ağ hatası. İnternet bağlantınızı kontrol edin.";
  }

  // Map içinde varsa, orada ne tanımlıysa onu dön
  if (statusMessages[status]) {
    return statusMessages[status];
  }

  // Tanımsız herhangi bir status kodu için genel mesaj
  return "Beklenmedik bir hata oluştu. Lütfen tekrar deneyin.";
}
